// The single source of the four-image captions shown on the editor upload
// blocks, keyed by the image's stored `type`. Reused by the check/voucher
// editors and by the per-image validation messages so both always match.
export const imageCaptions = {
    Check_Front_tif: 'תמונה קדמית מסוג TIF',
    Check_Back_tif: 'תמונה אחורית מסוג TIF',
    Check_Front_jpg: 'תמונה קדמית מסוג JPG',
    Check_Back_jpg: 'תמונה אחורית מסוג JPG',
    Voucher_Front_tif: 'תמונה קדמית מסוג TIF',
    Voucher_Back_tif: 'תמונה אחורית מסוג TIF',
    Voucher_Front_jpg: 'תמונה קדמית מסוג JPG',
    Voucher_Back_jpg: 'תמונה אחורית מסוג JPG',
}

export function imageCaption(type) {
    return imageCaptions[type] ?? ''
}
